import React, { useEffect, useRef } from 'react';

const RSW_VIDEO = '/videos/rsw-hero.mp4';
const HERO_VIDEO_FALLBACK = '/videos/skyway-hero.mp4';

// Fullscreen background video, RSW-style. Sits fixed behind the entire page.
// Landing sections above render on top; the hero uses transparent overlay
// so users see the video, and downstream sections have opaque white cards.
const BackgroundVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = true;
    v.load();
    const tryPlay = () => v.play().catch(() => {});
    tryPlay();
    const onCanPlay = () => tryPlay();
    v.addEventListener('canplay', onCanPlay);
    return () => v.removeEventListener('canplay', onCanPlay);
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-testid="rsw-bg-video">
      <video
        ref={videoRef}
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="https://images.unsplash.com/photo-1645615094859-713627503c5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxza3l3YXklMjBtb25vcmFpbCUyMGZ1dHVyaXN0aWN8ZW58MHx8fHwxNzg0MTQyNDc3fDA&ixlib=rb-4.1.0&q=85"
        aria-hidden="true"
      >
        <source src={RSW_VIDEO} type="video/mp4" />
        <source src={HERO_VIDEO_FALLBACK} type="video/mp4" />
      </video>
      {/* Subtle darkening for text legibility over video */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#040d08]/40 via-[#040d08]/20 to-transparent" />
    </div>
  );
};

export default BackgroundVideo;
